import React from "react";
import withLayout from "../../../components/desktop/layout/component";
import { Helmet } from "react-helmet-async";
import TermsInfo from "../../../components/shared/terms-info/component";
import { appUrl } from "../../../constants/url-constants";

const TermsOfUse = () => {
    return (
        <React.Fragment>
            <Helmet>
                <title>Cars24 | terms of use</title>
                <link href={`${appUrl()}/terms-of-use/`} rel="canonical" />
            </Helmet>
            <TermsInfo/>
        </React.Fragment>
    );
};

export default withLayout(TermsOfUse);
